import { connect } from 'react-redux';
import ProfileParser from '../../../components/profile/ProfileParser';

export default connect(state => ({}), {})(ProfileParser);
